import { Badge, BadgeVariant } from '@moment/design-system-ui/badge'

import { AllocationStatus } from '@/types/api/events/allocation-update'

interface AllocationStatusBadgeProps {
  status: AllocationStatus
}

const statusVariantMap: Record<AllocationStatus, BadgeVariant> = {
  [AllocationStatus.Approved]: BadgeVariant.Success,
  [AllocationStatus.Calculated]: BadgeVariant.Processing,
  [AllocationStatus.Canceled]: BadgeVariant.Neutral,
  [AllocationStatus.Created]: BadgeVariant.Processing,
  [AllocationStatus.Failed]: BadgeVariant.Danger,
  [AllocationStatus.Rejected]: BadgeVariant.Danger,
  // Intentionally showing success for submitted, context:
  // For some custodians we get a follow-up succeed event (e.g. LPL)
  // For other custodians we end at a submitted event (e.g. Schwab, Pershing, Fidelity)
  // Going to show success for both for now, though probably can eventually filter on custodian_id (when we make it friendly),
  // but it will be a pain to thread that data through the timeline and badges
  [AllocationStatus.Submitted]: BadgeVariant.Success,
  [AllocationStatus.Succeeded]: BadgeVariant.Success,
}

export function AllocationStatusBadge({ status }: AllocationStatusBadgeProps) {
  const variant = statusVariantMap[status] || BadgeVariant.Neutral

  return (
    <Badge className="capitalize" variant={variant}>
      {status.replace('_', ' ')}
    </Badge>
  )
}
